// extracted by mini-css-extract-plugin
export var currencyInput = "_p9-1";
export var currencySymbol = "_p9-0";